@if(component){
<div class="flex-column wrap m-t-10 m-b-10">
    <text-box class="w-6 w-12-s w-12-m flex flex-middle"
              [data]="component"></text-box>
    @if(models.length){
    <div class="m-t-5"
         *ifSize="'XL'"
         [grid]="4"
         [gridColumnGap]="'20px'"
         [gridRowGap]="'20px'">
        @for(model of models; track model.id){
        <href class="b-a b-col-5 overflow-hidden pos-relative"
              [link]="model?.url || ''"
              style="border-radius: 12px;">
            <df-image-wrapper class="w-12">
                <img [ratio]="1"
                     [dfImage]="model.data?.image || ''"
                     [alt]="model.data?.name || ''">
            </df-image-wrapper>
            <div class="pos-absolute center block z-5 _label">
                <span [buttonStyle]="'button-2'">
                    <span class="no-wrap lowercase">
                        {{model.name}}
                    </span>
                </span>
            </div>
        </href>
        }
    </div>
    <div *ifSize="'MS'"
         class="m-t"
         [grid]="2"
         [gridColumnGap]="'16px'"
         [gridRowGap]="'16px'">
        @for(model of models; track model.id){
        <href [link]="model?.url || ''">
            <div class="w-12 b-a b-col-5 overflow-hidden"
                 style="border-radius: 12px;">
                <df-image-wrapper class="w-12">
                    <img [ratio]="1"
                         [dfImage]="model.data?.image || ''"
                         [alt]="model.data?.name || ''">
                </df-image-wrapper>
            </div>
            <p class="h4 m-t-2">{{model.name}}</p>
            <span class="s1 m-t-2"
                  [buttonStyle]="'text-button'">
                {{'View' | translate}}
            </span>
        </href>
        }
    </div>
    }
</div>
}